package com.daytimegaming.ourdailyfinances.presentation.dashboard

import com.daytimegaming.ourdailyfinances.domain.model.DashboardDetail
import com.daytimegaming.ourdailyfinances.domain.model.SecurityPerformance
import com.daytimegaming.ourdailyfinances.domain.model.Holding

sealed class DashboardDetailScreenState {
    data object Loading : DashboardDetailScreenState()
    data class Error(val message: String) : DashboardDetailScreenState()
    data class Loaded(
        val detail: DashboardDetail,
        val securityPerformance: SecurityPerformance? = null,
        val holdings: List<Holding> = emptyList(),
        val isSecurityPerformanceLoading: Boolean = false,
    ) : DashboardDetailScreenState()
}
